import { z } from "zod";

export const signInSchema = z.object({
  email: z.string().refine((val) => /\S+@\S+\.\S+/.test(val), {
    message: "Please enter a valid email address",
  }),
  password: z.string().min(8, "Password must be at least 8 characters"),
});

export type SignInFormType = z.infer<typeof signInSchema>;
